export default __webpack_public_path__ + "static/media/transitscreen_tile.ec16652d.png";